module.exports = __webpack_public_path__ + "static/media/Team 15 - Wizards of Oz.17992933.png";